import CityPageTemplate from "../city-template/CityPageTemplate";
import { roanokeVaConfig } from "./data";

export default function RoanokeVaPage() {
  return <CityPageTemplate config={roanokeVaConfig} />;
}